var _rect, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExistingProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2271_7282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 8C21.8945 8 21 8.89551 21 10V11.603C21 12.0593 20.6895 12.4534 20.2559 12.5957C19.875 12.7207 19.502 12.864 19.1387 13.0249L18.8164 13.1733L18.584 13.2886C18.2969 13.4338 17.9648 13.4475 17.6816 13.3298C17.5625 13.2805 17.4512 13.2083 17.3555 13.1128L16.2227 11.9795C15.4414 11.1982 14.1758 11.1982 13.3945 11.9795L11.9805 13.3936C11.1992 14.1746 11.1992 15.4407 11.9805 16.2217L13.1133 17.3552C13.4375 17.678 13.4961 18.1763 13.2891 18.5835C13.0176 19.1191 12.7852 19.6777 12.5957 20.2559C12.5332 20.4465 12.4238 20.6133 12.2793 20.7402C12.1895 20.8206 12.0859 20.885 11.9727 20.9297C11.8574 20.9751 11.7324 21 11.6035 21H10C8.89453 21 8 21.8955 8 23V25C8 26.1045 8.89453 27 10 27H11.6035C12.0605 27 12.4551 27.3105 12.5957 27.7441C12.6973 28.0547 12.8125 28.3596 12.9375 28.6584C13.0469 28.9158 13.1641 29.1687 13.2891 29.4165C13.418 29.6689 13.4434 29.9563 13.3672 30.2153C13.3203 30.374 13.2363 30.522 13.1133 30.6448L11.9805 31.7783C11.1992 32.5593 11.1992 33.8254 11.9805 34.6064L13.3945 36.0205C13.5449 36.1716 13.7148 36.2935 13.8945 36.386C14.1602 36.5217 14.4473 36.5947 14.7383 36.605C15.2734 36.6243 15.8145 36.4294 16.2227 36.0205L17.3555 34.8872C17.6797 34.5645 18.1777 34.5051 18.584 34.7114C19.1191 34.9827 19.6777 35.2148 20.2559 35.4043C20.6895 35.5466 21 35.9407 21 36.397V38C21 39.1045 21.8945 40 23 40H25C25.3887 40 25.752 39.8892 26.0586 39.6973C26.625 39.3438 27 38.7158 27 38V36.397C27 36.1646 27.0801 35.9482 27.2168 35.7732C27.3477 35.6045 27.5312 35.4741 27.7441 35.4043C28.3223 35.2146 28.8809 34.9822 29.416 34.7107C29.8223 34.5044 30.3223 34.5637 30.6445 34.8862L31.7793 36.021C32.5605 36.802 33.8262 36.802 34.6074 36.0208L36.0215 34.6067C36.8027 33.8257 36.8027 32.5593 36.0215 31.7783L34.8867 30.6436C34.5645 30.3208 34.5039 29.8225 34.7109 29.4153C34.9824 28.8799 35.2148 28.3218 35.4043 27.7441C35.5449 27.3105 35.9395 27 36.3965 27H38C39.1055 27 40 26.1045 40 25V23C40 21.8955 39.1055 21 38 21H36.3965C36.2871 21 36.1816 20.9824 36.082 20.9497C35.8984 20.8889 35.7363 20.7764 35.6113 20.6284C35.5215 20.521 35.4492 20.3948 35.4043 20.2559L35.2695 19.8657C34.8613 19.9536 34.4355 20 34 20C30.6855 20 28 17.3137 28 14C28 13.5647 28.0469 13.1401 28.1348 12.7312C28.0059 12.6838 27.875 12.6387 27.7441 12.5957C27.5977 12.5476 27.4648 12.4707 27.3535 12.3723C27.1367 12.1797 27 11.905 27 11.603V10C27 8.89551 26.1055 8 25 8H23ZM24 30C27.3145 30 30 27.3137 30 24C30 20.6863 27.3145 18 24 18C20.6855 18 18 20.6863 18 24C18 27.3137 20.6855 30 24 30Z",
    fill: "#B81C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18C36.209 18 38 16.2092 38 14C38 11.7908 36.209 10 34 10C31.791 10 30 11.7908 30 14C30 16.2092 31.791 18 34 18Z",
    fill: "#B81C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2271_7282)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1.43555,
    width: 48,
    height: 48,
    fill: "url(#paint0_linear_2271_7282)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 44.5645,
    r: 35,
    fill: "url(#paint1_radial_2271_7282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: 1.2168,
    width: 54.716,
    height: 81.7202,
    transform: "rotate(-50.4948 -29 1.2168)",
    fill: "url(#paint2_radial_2271_7282)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16.2168,
    width: 44.9128,
    height: 41.979,
    transform: "rotate(-50.4948 13 16.2168)",
    fill: "url(#paint3_radial_2271_7282)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_7282",
    x1: 0,
    y1: 46.5645,
    x2: 48,
    y2: -1.43555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE72F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE72F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2271_7282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42 44.5645) rotate(90) scale(35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B103",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2271_7282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.64198 42.0769) rotate(90) scale(40.8601 27.358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68511",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2271_7282",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4564 37.2063) rotate(90) scale(20.9895 22.4564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D904",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingProducts);
export default __webpack_public_path__ + "static/media/ExistingProducts.da305464d7c3add95f75b02710b98903.svg";
export { ForwardRef as ReactComponent };